import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { SiteModel } from 'src/app/models/site.model';
import { ApiRequestService } from 'src/app/shared/api-request.service';
import { UtilsService } from 'src/app/shared/utils.service';
import { RBACService } from '../../../shared/rbac.service';
import { TagModel } from '../../../models/tag.model';

@Component({
  selector: 'app-sites-noticeboard-edit',
  templateUrl: './sites-noticeboard-edit.component.html',
  styleUrls: ['./sites-noticeboard-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SitesNoticeboardEditComponent implements OnInit {
  // the site model placeholder
  site: SiteModel = new SiteModel();

  inProgress: boolean = false;

  // Content loaded boolean is used to delay the initialization of the TinyMCE editor.
  // This prevents an error from triggering.
  contentLoaded: boolean = false;

  constructor(
    // public service: SitesService,
    public router: Router,
    public route: ActivatedRoute,
    public app: AppService,
    private api: ApiRequestService,
    public utils: UtilsService,
    public rbac: RBACService
  ) {}

  ngOnInit(): void {
    if (
      !this.rbac.userCanAccess(
        [
          RBACService.getPermission(
            RBACService.RBAC_F.F_SITES,
            RBACService.RBAC_A.A_EDIT
          )
        ],
        true
      )
    ) {
      this.rbac.showGenericAccessDeniedMessage(
        'You do not have permission to edit sites.'
      );
      this.router.navigate(['/sites']);
      return;
    }

    // Get the site id from the route params.
    const parent_id: number = Number(
      this.route.parent.snapshot.params['parent_id']
    );
    const child_id: number = Number(
      this.route.parent.snapshot.params['child_id']
    );

    // Check if we are updating a site or creating a new one.
    if (
      child_id ||
      (typeof this.route.parent.snapshot.params['child_id'] == 'undefined' &&
        parent_id)
    ) {
      // Store the site id.
      this.site.id = child_id ? child_id : parent_id;
      // get the data from the api
      this.api
        .makeRequest('get', 'v1/sites/' + this.site.id)
        .then(
          (response: any): void => {
            // apply the data
            this.site.apply(response.data);
            // Change the content loaded boolean to true to notify the TinyMCE editor that it can be initialized.
            this.contentLoaded = true;
          }
        )
        .catch(
          (err: any): void => {
            this.utils.showModal('Error', err.error.message);
          }
        );
    }
  }

  /**
   * Handles the submission of the form. Validates form input, checks user permissions, and triggers the API call to update the site details.
   *
   * @param {NgForm} form - The form object containing user input.
   * @return {void} No value is returned from this method.
   */
  onSubmit(form: NgForm): void {
    if (
      !this.rbac.userCanAccess(
        [
          RBACService.getPermission(
            RBACService.RBAC_F.F_SITES,
            RBACService.RBAC_A.A_EDIT
          )
        ],
        true
      )
    ) {
      this.rbac.showGenericAccessDeniedMessage();
      return;
    }

    if (!form.valid) {
      alert('Please make sure you enter all fields with valid information.');
      return;
    }

    if (this.inProgress || !this.site.id) {
      return;
    }

    this.inProgress = true;

    this.api
      .makeRequest('put', 'v1/sites/' + this.site.id, this.site)
      .then(
        (response: any): void => {
          this.utils.showToast('The noticeboard was updated.');
          this.inProgress = false;
        }
      )
      .catch(
        (err: any): void => {
          this.utils.showModal('Error', err.error.message);
          this.inProgress = false;
        }
      );
  }
}
